import { CreateIntentResponse } from "../@types/Billing/Payments";
import {
  createOneIntent,
  storeCardMethod,
} from "../services/billing/payments/";

export default function usePayment() {
  async function createIntent(): Promise<CreateIntentResponse | null> {
    return createOneIntent();
  }

  async function addCardMethod(
    token: string,
    fullName: string,
    cpf: string
  ): Promise<boolean> {
    const status = await storeCardMethod(token, fullName, cpf);

    if (status === 201) {
      return true;
    }

    return false;
  }

  return { createIntent, addCardMethod };
}
